<template>
    <div>
        <v-container v-if="showMain == true">
            <v-layout>
                <v-flex xs12 sm12 md12 lg12 xl12 style="text-align: right">
                    <v-btn color="primary" @click="onExportReport">
                        <v-icon dark left>cloud_download</v-icon>
                        {{$t('lang.common.exportReport') }}
                    </v-btn>
                    <v-btn class="yoprimary" dark @click="onSendEmail">
                        <v-icon dark left>email</v-icon>
                        {{$t('lang.common.sendEmail')}}
                    </v-btn>
                    <v-btn class="yoprimary" dark @click="onSendZalo">
                        <v-icon dark left>chat</v-icon>
                        {{$t('Zalo')}}
                    </v-btn>
                </v-flex>
            </v-layout>
            <v-layout class="reportPanel">
                <v-flex xs4 sm4 md4 lg4 xl4 style="text-align: center;">
                    <div class="label">
                        ĐIỂM TRUNG BÌNH
                    </div>
                    <div class="content" style="font-size: 50px;font-weight: bold">
                        {{averateMark}}
                    </div>
                </v-flex>
                <v-flex xs8 sm8 md8 lg8 xl8>
                    <canvas id="mark-report-chart-2"/>
                </v-flex>
            </v-layout>
            <v-layout>
                <v-flex xs12 sm12 md12 lg12 xl12>
                    <v-data-table :headers="exerciseReportHeaders" class="elevation-1"
                                  :items="exerciseReport" hide-actions>
                        <template slot="items" slot-scope="props">
                            <td class="text-xs-left">{{ props.item["userName"] }}</td>
                            <td class="text-xs-right">{{ props.item["mark"] }}</td>
                            <td class="text-xs-right">{{ props.item["rank"]}}</td>
                            <td class="text-xs-left">{{ props.item["teacherComment"] }}</td>
                            <td class="text-xs-left">{{ props.item["teacherCommentImprove"] }}</td>
                        </template>
                    </v-data-table>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
    import axios from "axios";
    import {message} from "@/shared/message";
    import DoQuiz from "../doQuiz";
    import DoEssay from "../doEssay";

    export default {
        name: "answer-report",
        components: {DoEssay, DoQuiz},
        props: {
            classId: {
                type: String | Number,
                default: null
            },

            exerciseId: {
                type: String | Number,
                default: null
            },

            exercise: {
                type: Object,
                default: null
            },

            exerciseType: {
                type: String | Number,
                default: null
            },
        },

        data: () => ({
            studentId: null,
            showMain: true,
            averateMark: null,
            exerciseReportHeaders: [
                {
                    text: "Họ Tên",
                    align: "left",
                    sortable: false,
                    value: "question"
                },
                {
                    text: "Điểm",
                    align: "right",
                    sortable: false,
                    value: "true"
                },
                {
                    text: "Xếp hạng",
                    align: "right",
                    sortable: false,
                    value: "rank"
                },
                {
                    text: "Nhận xét bài tập",
                    align: "left",
                    sortable: false,
                    value: "teacherComment"
                },
                {
                    text: "Nhận xét thái độ học tập",
                    align: "left",
                    sortable: false,
                    value: "teacherCommentImprove"
                }
            ],
            exerciseReport: [],
        }),

        computed: {},

        watch: {},

        created() {
            this.init();
        },

        methods: {
            init: function () {
                this.getMarkReport();
                this.getListStudentMark();
            },

            getMarkReport: function () {
                axios.post(process.env.VUE_APP_API_URL + "/exercise/getMarkReportOfExercise?classId=" + this.classId + "&exerciseId=" + this.exerciseId + "&exerciseType=" + this.exerciseType)
                    .then(
                        data => {
                            this.mapMark = data;
                            this.averateMark = data[0];
                            const ctxmark = document.getElementById('mark-report-chart-2');
                            const chartmark = new Chart(ctxmark, {
                                type: 'pie',
                                data: {
                                    labels: ["<50%", "50%-80%", ">80%"],
                                    datasets: [
                                        {
                                            data: [this.mapMark[5], this.mapMark[8], this.mapMark[10]],
                                            backgroundColor: [
                                                '#36a2eb',
                                                'orange', // Blue
                                                '#ffcd56',
                                                '#ff6384'
                                            ],
                                        }
                                    ]
                                },
                                options: {
                                    title: {
                                        display: true,
                                        text: 'Biểu đồ thống kê điểm cùa học sinh'
                                    }
                                },
                            });

                        },
                        error => {
                            message.error(error);
                        }
                    )
            },

            getListStudentMark: function () {
                axios.post(process.env.VUE_APP_API_URL + "/exercise/getListStudentMark?classId=" + this.classId + "&exerciseId=" + this.exerciseId + "&exerciseType=" + this.exerciseType)
                    .then(
                        data => {
                            this.exerciseReport = data;
                        },
                        error => {
                            message.error(error);
                        }
                    )
            },

            onExportReport: function () {
                let url = process.env.VUE_APP_API_URL + "/exercise/exportWord?classId=" + this.classId + "&exerciseId=" + this.exerciseId + "&exerciseType=" + this.exerciseType;
                window.location.href = url;
            },

            onSendEmail: function () {
                axios.post(process.env.VUE_APP_API_URL + "/exercise/sendReport?classId=" + this.classId + "&exerciseId=" + this.exerciseId + "&exerciseType=" + this.exerciseType)
                    .then(
                        data => {
                            if (data.success) {
                                message.success("Gửi mail thành công");
                            } else {
                                message.error("Gửi mail không thành công");
                            }

                        },
                        error => {
                            message.error(error);
                        }
                    )
            },

            onSendZalo: function () {
                //let url = encodeURIComponent("https://localhost:8082/#/sendZalo/");
                let url = process.env.VUE_APP_FRONTEND_URL + "/#/sendZalo";
                console.log(url);
                let state = this.classId + "_" + this.exerciseId + "_" + this.exerciseType;
                url = encodeURIComponent(url);
                console.log(url);
                window.location.href = "https://oauth.zaloapp.com/v3/permission?app_id=2865613710705099529&redirect_uri=" + url + "&state=" + state;
            }
        }
    };
</script>